import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import NotFound from '../pages/NotFound';

interface RoleRouteProps {
  children: React.ReactNode;
  allowedRoles: string[];
  permissionPath?: string;
}

const RoleRoute: React.FC<RoleRouteProps> = ({ children, permissionPath }) => {
  const { user, allowedPaths } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (permissionPath && !allowedPaths.has(permissionPath)) {
    return <NotFound />;
  }

  return <>{children}</>;
};

export default RoleRoute;
